import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putCategory } from '../Api'

export default generateApiAction({
  baseType: Types.CATEGORIES.PUT,
  api: putCategory,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/categories/PutAction.js